import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PasswordField from 'apps/new-web/views/components/password-field';
import PrimaryCta from 'apps/new-web/views/components/primary-button';
import BaseComponent from 'apps/new-web/views/component';
import I18n from 'apps/new-web/views/components/i18n';
import ErrorMessage from 'apps/new-web/views/components/error-message';
import { validateFields as validate } from './validator';
import { renderMuiTextField } from '../material-ui-redux-fields';

export class PureLoginForm extends BaseComponent {

  static get propTypes() {
    return {
      handleSignIn: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func.isRequired,
      invalid: PropTypes.bool,
      error: PropTypes.string,
      submitting: PropTypes.bool,
      switchToSignup: PropTypes.func,
      hideTitle: PropTypes.bool
    };
  }

  static get defaultProps() {
    return {
      emailLabel: I18n.translate('Email address')
    };
  }

  render() {
    const { handleSignIn, handleSubmit, invalid, error, submitting, submitSucceeded, switchToSignup, hideTitle, emailLabel } = this.props;
    return (
      <form className="login-form" onSubmit={ handleSubmit(handleSignIn) }>
        { !hideTitle &&
          <h3 className="section-title"><I18n>Log In</I18n></h3>
        }
        <Field
          name="email"
          id="login_form-email"
          component={ renderMuiTextField }
          label={ emailLabel }
          fullWidth={ true }
        />
        <PasswordField />
        { error && <ErrorMessage> { error } </ErrorMessage> }
        <PrimaryCta
          label={ submitting || submitSucceeded ? I18n.translate('Processing...', 'The user needs to wait while data is submitted') : I18n.translate('Log In') }
          buttonType="submit"
          disabled={ invalid || submitting || submitSucceeded }
        />
        { switchToSignup &&
          <div className="create-prompt">
            <I18n>Need an iFIT account?</I18n>
            <a onClick={ switchToSignup } >
              <I18n> Join now </I18n>
            </a>
          </div>
        }
      </form>
    );
  }
}

export default reduxForm({
  form: 'login',
  validate
})(PureLoginForm);
